module.exports = __webpack_public_path__ + "static/media/carousel-6.4f1750b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-6.jpg
// module id = 152
// module chunks = 1